export function cleanUpSurveyBeforeSave(survey) {
    let cleanedSurvey = JSON.parse(JSON.stringify(survey));
    for (let questionIdx = 0; questionIdx < cleanedSurvey.questions.length; questionIdx ++) {
        let currentQuestion = cleanedSurvey.questions[questionIdx];
        cleanUpQuestionBeforeSurveySave(currentQuestion);
        cleanUpQuestionSkipsBeforeSurveySave(currentQuestion, cleanedSurvey.questions);
    }
    return cleanedSurvey;
}

export function cleanUpQuestionSkipsBeforeSurveySave(currentQuestion, questionsList) {
    const currentQuestionIndex = questionsList.findIndex((elem) => elem.id === currentQuestion.id);
    const filteredQuestionsList = questionsList.filter((elem, index) => index < currentQuestionIndex && ["singleChoice", "multipleChoice"].includes(elem.type));

    if(currentQuestion.skipGroup) {
        const skipQId = currentQuestion.skipGroup[0].skipArray[0].question_id;
        const skipQType = currentQuestion.skipGroup[0].skipArray[0].skipQtype;
        const skipValues = currentQuestion.skipGroup[0].skipArray[0].value;
        if(skipQId && skipQType && skipValues) {
            const skipQuestion = filteredQuestionsList.find((elem) => elem.id === skipQId);
            if(skipQType !== "multipleChoice") {
                delete currentQuestion.skipGroup;
                return;
            }
            if(skipQuestion && skipValues.length > 0){
                const optionsSkipQ = skipQuestion.options;
                const choicesValues = skipQuestion.choices.map((elem, index) => elem.value);
                if(optionsSkipQ && optionsSkipQ.noDKNA && optionsSkipQ.noDKNA === "false") {
                    choicesValues.push("999");
                }
                const allSkipValuesAreValid = skipValues.reduce((prev, next) => {return prev && choicesValues.includes(next)}, true)
                if(!allSkipValuesAreValid) {
                    delete currentQuestion.skipGroup;
                    return;
                }
            } else {
                delete currentQuestion.skipGroup;
                return;
            }
        } else {
            delete currentQuestion.skipGroup;
            return;
        }
    }
}

export function duplicateQuestion(question, duplicateQuestionId) {
    let cleanedQuestion = JSON.parse(JSON.stringify(question));
    delete cleanedQuestion.question_id;
    if (cleanedQuestion.choices) {
        cleanedQuestion.choices.map((choice) => {choice.choice_id = null; return choice;});
    }
    if (cleanedQuestion.selects) {
        cleanedQuestion.selects.map((select) => {
            select.select_id = null;
            select.id = select.id.replace(question.id, duplicateQuestionId);
            if (select.options) {
                select.options.map((option) => {option.options_id = null; return option;})
            }
            return select;
        });
    }
    return cleanedQuestion;
}

function cleanUpQuestionBeforeSurveySave(question) {
    switch(question.type) {
        case "singleChoice":
            cleanUpSingleChoiceQuestion(question);
            return;
        case "multipleChoice":
            cleanUpMultipleChoiceQuestion(question);
            return;
        case "text":
            cleanUpTextQuestion(question);
            return;
        case "selects":
            cleanUpMatrixQuestion(question);
            return;
        case "slider":
            cleanUpSliderQuestion(question);
            return;
        case "multipleOpen":
            cleanUpMultipleOpenQuestion(question);
            return;
        case "number":
            cleanUpNumberQuestion(question);
            return;
        case "rating":
            cleanUpRatingQuestion(question);
            return;
        default:
            return;
    }
}

function cleanUpSingleChoiceQuestion(question) {
    removeEmptyChoicesFromDefaultQuestion(question);
}

function cleanUpMultipleChoiceQuestion(question) {
    removeEmptyChoicesFromDefaultQuestion(question);
}

function removeEmptyChoicesFromDefaultQuestion(question) {
    question.choices = question.choices.filter(filterFunction);
    for (let i = 0; i < question.choices.length; i++) {
        question.choices[i].value = (i + 1).toString();
    }
}

const filterFunction = (choice) => {return typeof choice.label !== "undefined" && choice.label !== ""};

function cleanUpTextQuestion(question) {
    // TODO: implement for text question story
}

function cleanUpMatrixQuestion(question) {
    question.selects = question.selects.filter(filterFunction);
    question.selects.forEach((select) => {
        select.options = select.options.filter(filterFunction)
    });
}

function cleanUpSliderQuestion(question) {
    // TODO: implement for slider question story
}

function cleanUpMultipleOpenQuestion(question) {
    question.selects = question.selects.filter(filterFunction);
}

function cleanUpNumberQuestion(question) {
    // TODO: implement for number question story
}

function cleanUpRatingQuestion(question) {
    // TODO: implement for rating question story
}